import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons } from "@components";
import { AttachmentPostingForm } from "./AttachmentPostingForm";

import { AttachmentPostingType } from "@type/HRM/postings";
import { attachmentPostingValidation } from "@validations/HRM/employee/postingsValidation";

export const NewAttachmentPosting = ({
  handleNewAttachmentPostingFormShow,
  changeAttachmentPostingsInfo,
}: {
  handleNewAttachmentPostingFormShow: any;
  changeAttachmentPostingsInfo: any;
}) => {
  const methods = useForm<AttachmentPostingType>({
    resolver: yupResolver(attachmentPostingValidation),
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<AttachmentPostingType> = (
    data: AttachmentPostingType,
  ) => {
    changeAttachmentPostingsInfo(data);
    handleNewAttachmentPostingFormShow(false);
  };

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        <AttachmentPostingForm id="TEMP_ATTACHMENT_POSTING_INFO" />
        <ActionButtons
          disabled
          closeAction={() => handleNewAttachmentPostingFormShow(false)}
        />
      </form>
    </FormProvider>
  );
};
